module.exports = __webpack_public_path__ + "img/logo-istry-dashboard.e30d4b24.png";